/**
 * 下载相关的常量定义
 */

/** 默认文件名 */
export const 默认下载文件名 = 'download'
export const 默认图像文件名 = 'image'
export const 原始图像文件名 = 'original-image'
export const 无缝纹理文件名 = 'seamless-texture'

/** MIME 类型 */
export const MIME类型_JPEG = 'image/jpeg'
export const MIME类型_PNG = 'image/png'
export const MIME类型前缀_IMAGE = 'image/'

/** 文件扩展名 */
export const 扩展名_JPG = '.jpg'

/** 错误消息 */
export const 错误消息_无效DATAURL = '无效的 DataURL 格式'
export const 错误消息_保存图像失败 = '保存图像失败:'
export const 错误消息_CANVAS转BLOB失败 = 'Canvas 转换为 Blob 失败'

/** 协议前缀 */
export const 协议前缀_BLOB = 'blob:'

/** HTML 元素标签 */
export const HTML标签_链接 = 'a'

/** 下载质量 */
export const JPEG最高质量 = 1.0

/** 图像格式 */
export const 格式_JPG = 'jpg'
export const 格式_JPEG = 'jpeg'
export const 格式_PNG = 'png'
